module.exports = __webpack_public_path__ + "static/media/dictionary.f74e8a94.svg";